
<script>
	import listBase from '@_system/components/base/list.vue'
	import statisticsIndex from './statistics/index.vue'
	export default {
		extends: listBase,
		name: 'salemanscoreIndex',
		props: {

		},
		data() {
			return {
				moduleName: 'salemanscore',
				windowName: '客服积分',
				windowType: 'modal',
				currentRow:null,
				commit_time:null
			}
		},
		render(h) {
			this.$slots.plug = [
				<statistics-index commit_time={this.commit_time} ref="statisticsIndex" />,
			]
			return listBase.render.call(this, h)
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			detail() {
				let form = this.$refs[this.moduleName + '_list'].getProxyInfo().form
				this.commit_time = form.commit_time
				this.$refs.statisticsIndex.modalShow()
			
			}
		},
		components: {
			statisticsIndex
		}
	}
</script>
